import * as z from "zod/v4";
import {
  RackCellSchema,
  WallSchema,
  WarehouseCellSchema,
} from "./warehouse-cell";

export const WarehouseGridSchema = z.object({
  width: z.number().int().positive(),
  height: z.number().int().positive(),
  grid: z.array(z.array(WarehouseCellSchema)),
  racks: z.record(z.string(), RackCellSchema),
  walls: z.array(WallSchema),
  binCoordinates: z.record(
    z.string(),
    z.object({ x: z.number(), y: z.number() }),
  ),
});
export type WarehouseGrid = z.infer<typeof WarehouseGridSchema>;
export interface IWarehouseGridSchema extends z.ZodType<WarehouseGrid> {}
